<template>
    <div class="layout-wrapper">
        <div class="container-fluid">
            <div class="col-12">
                <div class="card shadow">
                    <div class="card-header  bg-accent-grad glow-accent text-center">
                        <h3 class="text-white">مدیریت دسته بندی های کالاها</h3>

                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="card-header admin-header w-100">

                                <h5 class="text-accent-light">دسته های کالا</h5>

                                <div class="text-left">

                                    <button class="btn btn-link text-accent-light"
                                            @click="onAddCategoryClicked()"><i class="fa fa-plus"></i>
                                    </button>
                                </div>
                            </div>

                            <div class="col-12 input-group round mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">جستجو</span>
                                </div>
                                <input class="form-control" v-model="search" @input="searching()"
                                       placeholder="حداقل 2 کاراکتر از دسته بندی کالا را وارد کنید">
                            </div>
                            <div class="table-responsive">
                                <div v-if="!isLoading">
                                    <preloader/>
                                </div>
                                <div v-else>
                                    <div v-if="mycategorys.length===0">
                                        <p class="text-center mt-3">هیچ دسته کالایی ثبت نشده است. برای ثبت روی دکمه + کلیک
                                            کنید</p>

                                    </div>
                                    <div v-else>
                                        <table class="table table-hover table-striped mb-3">
                                            <thead>
                                            <tr>
                                                <th>نام دسته بندی</th>
                                                <th>دسته مادر</th>

                                                <th class="text-center">عملیات</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr v-for="it in mycategorys">

                                                <td class="text-nowrap">{{it.categoryName}}</td>
                                                <td class="text-nowrap">{{it.parentCategoryName}}</td>
                                                <td class="text-center text-nowrap"><i
                                                        class="fa fa-pencil-square-o px-3 clickable"
                                                        style="font-size: larger"
                                                        @click="editItem(it)"
                                                        title="ویرایش آیتم"></i>
                                                    | <i class="fa fa-trash-o px-3 clickable"
                                                         style="font-size: larger"
                                                         @click="deleteItem(it)"
                                                         title="حذف آیتم"></i>

                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--///////////////////////////////////////////////////////////////////////////////////////////////////-->
            <modal show="false" ref="insertModal">
                <div class="row p-3">
                    <div class="col-12 text-center">
                        <h1 v-if="categoryMode === 'create'">ثبت دسته کالا</h1>
                        <h1 v-else>ویرایش دسته کالا</h1>
                    </div>
                    <div class="col-lg-8 mb-4">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text">نام دسته کالا</span>
                            </div>
                            <input class="form-control" v-model="categoryModel.categoryName">
                        </div>
                    </div>
                    <div class="col-lg-4 ">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text">نام دسته مادر</span>
                            </div>
                            <vs-select @onSearch="onDropDownFocused"
                                       @onSearchBlurred="onDropDownBlurred"
                                       ref="evidence"
                                       :data="categorys"
                                       :mode="'create'"
                                       :selected-val="filterCategory"
                                       :header="{multiple: false, label: 'categoryName'}"
                                       aria-placeholder="فیلتر براساس دسته بندی کالا"
                                       @onChange="onCategoryChange"></vs-select>
                        </div>
                    </div>
                    <div class="col-lg-8 mb-4">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text">پیش کد کالا</span>
                            </div>
                            <input class="form-control" v-model="categoryModel.defaultCode">
                        </div>
                    </div>


                    <div class="col-lg-6 offset-lg-3 text-center">
                        <button class="btn btn-success btn-round clickable mt-3" :disabled="isSending"
                                @click="updatecategory" v-if="categoryMode=='edit'">ویرایش دسته
                        </button>
                        <button class="btn btn-success btn-round clickable mt-3" :disabled="isSending"
                                @click="createcategory" v-else>ثبت دسته
                        </button>
                        <button class="btn btn-primary btn-round clickable mt-3 mx-3"
                                @click="cancelcategory">انصراف
                        </button>
                    </div>
                </div>
            </modal>
            <!--////////////-->

        </div>
    </div>
</template>

<script>
    import BaseService from "../../_framework/api/BaseService";
    import DatePicker from '../../_framework/vue-persian-datetime-picker/VuePersianDatetimePicker.vue';
    import VsSelect from "../../_framework/VsSelect";
    import Utils from "../../_framework/utils/Utils";
    import Moment from 'moment-jalali';
    import Constants from "../../_framework/Constants";

    export default {
        name: "category",
        components: {VsSelect, DatePicker},
        data() {
            return {

                showArchive: false,
                isSending: false,
                isLoading: false,
                mycategorys: [],
                categorys: [],

                categoryMode: "",
                categoryModel: {
                    id: 0,
                    categoryName: "",
                    parentCategoryId: null,
                    companyId : 0,
                    defaultCode:"",

                },
                search: "",


                filterCategory : "",



            }
        },
        mounted() {
            this.getMyCategorys();
             this.getCategorys();
        },
        methods: {
            onCategoryChange(val) {
                if (val && val.categoryName) {

                    this.filterCategory = val.parentCategoryName;
                    this.categoryModel.parentCategoryId = val.id;
                } else {

                }
            },

            onAddCategoryClicked() {
                this.categoryModel = {
                    id: 0,
                    categoryName: "",
                    parentCategoryId: null,
                    companyId: 0,
                };
                this.categoryMode = "create";
                this.$refs.insertModal.showModal();
            },
            getMyCategorys() {
                new BaseService("category", "/Getcategory").getList().then(response => {
                    this.mycategorys = response.data;
                    this.isLoading = true;
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },
            getCategorys() {
                new BaseService("category", "/Getcategory").getList().then(response => {
                    this.categorys = response.data;
                    this.isLoading =true;

                }).catch(error => {
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },

            editItem(item) {

                this.categoryModel = item;
                this.categoryMode = "edit";
                this.filterCategory = item.parentCategoryName;
                this.categoryModel.parentCategoryId=item.parentCategoryId;

                this.$refs.insertModal.showModal();
            },
            deleteItem(item) {
                if (confirm("آیا از حذف این آیتم اطمینان دارید؟")) {
                    new BaseService("category", "Deletecategory").delete(item.id).then(response => {
                        this.$noty.warning("آیتم با موفقیت حذف شد");
                        this.getMyCategorys();
                    }).catch(error => {
                        Utils.handleErrorWithNotification("این آیتم در جای دیگری استفاده شده است، ابتدا موارد وابسته را پاک کنید", this.$noty);
                    })
                }
            },

            updatecategory() {
                this.isSending = true;
                new BaseService("category", "/Updatecategory").update(this.categoryModel).then(response => {
                    this.$noty.success("محصول با موفقیت ویرایش شد");
                    this.isSending = false;
                    this.$refs.insertModal.hideModal();
                    this.getMyCategorys();
                }).catch(error => {
                    this.isSending = false;
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                    this.$refs.insertModal.hideModal();
                    this.getMyCategorys();
                });


            },
            createcategory() {
                this.isSending = true;
                new BaseService("category", "/Createcategory").create(this.categoryModel).then(response => {
                    this.$noty.success("دسته کالا با موفقیت ثبت شد");
                    this.$refs.insertModal.hideModal();
                    this.filterCategory="";
                    this.isSending = false;
                    this.getMyCategorys();
                }).catch(error => {
                    this.isSending = false;
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                    this.$refs.insertModal.hideModal();
                    this.getMyCategorys();
                });

            },
            cancelcategory() {
                this.$refs.insertModal.hideModal();
                this.filterCategory="";
                this.getMyCategorys();
            },

            searching() {
                if (this.search.length > 2) {
                    this.isLoading = false;
                    new BaseService("category", `/Searchcategory/${this.search}`).getList().then(response => {
                        this.mycategorys = response.data;
                        this.isLoading = true;
                    }).catch(error => {
                        Utils.handleErrorWithNotification(error.data, this.$noty);
                    });
                } else {
                    this.getMyCategorys();
                }
            },




        }
    }
</script>

<style lang="scss" scoped>
    .profile-image {
        margin: 0 auto 1rem auto;
    }

    .profile-image img {
        max-width: 150px;
        border-radius: 1rem;
        box-shadow: 0 10px 25px -10px rgba(0, 0, 0, 0.25);
    }
</style>